import { EntityResponse, Expert } from "../../types";
import {
    makeStyles, Theme, createStyles, Typography, CardMedia, useTheme, useMediaQuery
} from "@material-ui/core";
import React from "react";
import { getExpertTitles } from "../utils";
import { pictureURL, PictureSizes } from "../../settings";
import { colors } from "../../theme";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        pictureGridComponent: {
            display: "flex"
        },
        expertNameContainer: {
            paddingLeft: theme.spacing(3)
        },
        cardMediaLargeDesktop: {
            width: "8rem",
            height: "8rem",
            borderRadius: "4px"
        },
        cardMediaLargeMobile: {
            minHeight: theme.typography.pxToRem(103),
            minWidth: theme.typography.pxToRem(103),
            borderRadius: "4px"
        },
        cardMediaSmall: {
            minHeight: theme.typography.pxToRem(70),
            minWidth: theme.typography.pxToRem(70),
            borderRadius: "4px",
            paddingBottom: "15px"
        },
        name: {
            color: colors.darkBlue,
            fontSize: '22px'
        },
        title: {
            color: colors.darkBlue,
            fontSize: '18px'
        }
    }));

interface IExpertPictureNameAndTitle {
    expert: EntityResponse<Expert>,
    size?: "small" | "medium"
}

export const ExpertPictureNameAndTitle: React.FC<IExpertPictureNameAndTitle> = (props) => {
    const { expert, size } = props;

    const classes = useStyles();
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div className={classes.pictureGridComponent}>

            <CardMedia
                image={`${pictureURL}/${expert.uuid}.${PictureSizes["250x250"]}`}
                className={
                    size !== "small" ?
                        (mobile ? classes.cardMediaLargeMobile : classes.cardMediaLargeDesktop) :
                        classes.cardMediaSmall
                }
                title={"Expert picture"}
            />
            <div className={classes.expertNameContainer}>
                <Typography
                    variant={
                        size !== "small" ?
                            "h6" :
                            "subtitle1"
                    }
                    className={ classes.name }
                    id={"expertNameHeader"}
                >
                    { expert.data.Nimi }
                </Typography>
                <Typography
                    className={ classes.title }
                >
                    {getExpertTitles(expert.data)}
                </Typography>
            </div>
        </div>
    );
};
